const state = () => ({
    isLightMode: false,
})

const mutations = {
    changeTheme (state, payload) {
      // 变更状态
      state.isLightMode = payload
    }
}

  export default {
    namespaced: true,
    state,
    mutations
  }